/* kids-plp — category filtering + Quick Add
   Filtering is client-side: each pill carries data-filter, each card a
   data-categories list. Quick Add posts the block's chosen subscription SKU
   straight to /cart/add.js, then opens the theme's mini-cart. */

(function () {
  'use strict';

  function init(root) {
    var grid  = root.querySelector('[data-kids-plp-grid]');
    var pills = root.querySelectorAll('.kids-plp__pill');
    var empty = root.querySelector('[data-kids-plp-empty]');
    if (!grid) return;

    /* ---------- filtering ---------- */

    // Every filterable tile: cards plus the hero.
    var tiles = grid.querySelectorAll('[data-categories]');

    function keysOf(el) {
      return (el.getAttribute('data-categories') || '')
        .toLowerCase().split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }

    function apply(filter) {
      var shown = 0;
      Array.prototype.forEach.call(tiles, function (tile) {
        var match = filter === 'all' || keysOf(tile).indexOf(filter) !== -1;
        tile.hidden = !match;
        if (match) shown++;
      });
      if (empty) empty.hidden = shown > 0;
    }

    Array.prototype.forEach.call(pills, function (pill) {
      pill.addEventListener('click', function () {
        Array.prototype.forEach.call(pills, function (p) {
          p.classList.remove('kids-plp__pill--active');
          p.setAttribute('aria-pressed', 'false');
        });
        pill.classList.add('kids-plp__pill--active');
        pill.setAttribute('aria-pressed', 'true');
        apply((pill.getAttribute('data-filter') || 'all').toLowerCase().trim());
      });
    });

    // Respect whichever pill the merchant marked active in the customizer.
    var initial = root.querySelector('.kids-plp__pill--active');
    apply(initial ? (initial.getAttribute('data-filter') || 'all').toLowerCase().trim() : 'all');

    /* ---------- quick add ---------- */

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn || btn.disabled) return;

      var variant = btn.getAttribute('data-variant');
      if (!variant) return;

      var item = { id: Number(variant), quantity: 1 };
      var plan = btn.getAttribute('data-plan');
      if (plan) item.selling_plan = Number(plan);

      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || d.message || 'Add to cart failed'); });
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          // Open the theme's mini-cart if it's on the page.
          var opener = document.querySelector('.openCart');
          if (opener) opener.click();
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
        })
        .catch(function (err) {
          console.error('[kids-plp] quick add failed:', err);
          btn.textContent = 'Try again';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2200);
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-kids-plp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-kids-plp]').forEach(init);
  });
})();
